module.exports = __webpack_public_path__ + "static/img/baogaochaxun.3862d951.png";